/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentStatus,
  PaymentStatusOptional,
  PaymentStatusMetaI,
  PaymentStatusTrackedI,
} from "./payment-status";
import { PaymentStatusTracked, PaymentStatusMeta } from "./payment-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportDTO,
  ReportDTOOptional,
  ReportDTOMetaI,
  ReportDTOTrackedI,
} from "./report-dto";
import { ReportDTOTracked, ReportDTOMeta } from "./report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  StripeTransactionBase,
  StripeTransactionBaseOptional,
  StripeTransactionBaseMetaI,
  StripeTransactionBaseTrackedI,
} from "./stripe-transaction-base";
import {
  StripeTransactionBaseTracked,
  StripeTransactionBaseMeta,
} from "./stripe-transaction-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  StripeTransactionType,
  StripeTransactionTypeOptional,
  StripeTransactionTypeMetaI,
  StripeTransactionTypeTrackedI,
} from "./stripe-transaction-type";
import {
  StripeTransactionTypeTracked,
  StripeTransactionTypeMeta,
} from "./stripe-transaction-type";

/**
 *
 * @export
 * @interface StripePaymentReportDTO
 */
export interface StripePaymentReportDTOOptional extends ReportDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof StripePaymentReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof StripePaymentReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof StripePaymentReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof StripePaymentReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof StripePaymentReportDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof StripePaymentReportDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof StripePaymentReportDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
  /**
   *
   * @type {StripeTransactionType}
   * @memberof StripePaymentReportDTO
   */
  transactionType?: StripeTransactionType;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  stripePaymentIntent?: string;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  stripePaymentSecret?: string;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  transactionAmountCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof StripePaymentReportDTO
   */
  offSession?: boolean;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  amountReceived?: number;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  amountCapturable?: number;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  amountBase?: number;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  capturableDate?: Date;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  paidDate?: Date;
  /**
   *
   * @type {PaymentStatus}
   * @memberof StripePaymentReportDTO
   */
  paymentStatus?: PaymentStatus;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  orderId?: number;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  paymentDescription?: string;
}

export interface StripePaymentReportDTO
  extends StripePaymentReportDTOOptional, ReportDTO, StripeTransactionBase {
  /**
   *
   * @type {boolean}
   * @memberof StripePaymentReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof StripePaymentReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof StripePaymentReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof StripePaymentReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof StripePaymentReportDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof StripePaymentReportDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof StripePaymentReportDTO
   */
  typeCounts?: ReportTypeCountDTO[];
  /**
   *
   * @type {StripeTransactionType}
   * @memberof StripePaymentReportDTO
   */
  transactionType?: StripeTransactionType;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  stripePaymentIntent: string;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  stripePaymentSecret?: string;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  transactionAmountCents: number;
  /**
   *
   * @type {boolean}
   * @memberof StripePaymentReportDTO
   */
  offSession?: boolean;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  amountReceived?: number;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  amountCapturable?: number;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  amountBase?: number;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  capturableDate?: Date;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  paidDate?: Date;
  /**
   *
   * @type {PaymentStatus}
   * @memberof StripePaymentReportDTO
   */
  paymentStatus?: PaymentStatus;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  orderId?: number;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  paymentDescription?: string;
}

export interface StripePaymentReportDTOTrackedI extends ReportDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof StripePaymentReportDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof StripePaymentReportDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof StripePaymentReportDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof StripePaymentReportDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof StripePaymentReportDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof StripePaymentReportDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof StripePaymentReportDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
  /**
   *
   * @type {StripeTransactionType}
   * @memberof StripePaymentReportDTO
   */
  transactionType?: StripeTransactionType;
  transactionTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  stripePaymentIntent?: string;
  stripePaymentIntentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  stripePaymentSecret?: string;
  stripePaymentSecretIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  transactionAmountCents?: number;
  transactionAmountCentsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof StripePaymentReportDTO
   */
  offSession?: boolean;
  offSessionIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  amountReceived?: number;
  amountReceivedIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  amountCapturable?: number;
  amountCapturableIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  amountBase?: number;
  amountBaseIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  capturableDate?: Date;
  capturableDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  paidDate?: Date;
  paidDateIsSet: boolean;
  /**
   *
   * @type {PaymentStatus}
   * @memberof StripePaymentReportDTO
   */
  paymentStatus?: PaymentStatus;
  paymentStatusIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof StripePaymentReportDTO
   */
  orderId?: number;
  orderIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportDTO
   */
  paymentDescription?: string;
  paymentDescriptionIsSet: boolean;
}

transformDatesMap.set(
  "StripePaymentReportDTO",
  function (model: StripePaymentReportDTO) {
    const transformDateschildReports = transformDatesMap.get("ReportDTO");
    if (transformDateschildReports) {
      model.childReports?.forEach((sub) => {
        transformDateschildReports(sub);
      });
    }
    const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
    if (transformDatesmeta) {
      model.meta?.forEach((sub) => {
        transformDatesmeta(sub);
      });
    }
    const transformDatestypeCounts =
      transformDatesMap.get("ReportTypeCountDTO");
    if (transformDatestypeCounts) {
      model.typeCounts?.forEach((sub) => {
        transformDatestypeCounts(sub);
      });
    }
    if (typeof model.createdOn == "string")
      model.createdOn = new Date(model.createdOn);
    if (typeof model.capturableDate == "string")
      model.capturableDate = new Date(model.capturableDate);
    if (typeof model.paidDate == "string")
      model.paidDate = new Date(model.paidDate);
  },
);

export type StripePaymentReportDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  transactionType: PropertyMeta<StripeTransactionTypeMetaI>;
  //isDate: false
  //isDatetime: false
  stripePaymentIntent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  stripePaymentSecret: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  transactionAmountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  offSession: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  amountReceived: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountCapturable: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountBase: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  capturableDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  paidDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentStatus: PropertyMeta<PaymentStatusMetaI>;
  //isDate: false
  //isDatetime: false
  orderId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentDescription: PropertyMeta<MetaTypeBase<string>>;
}>;

export var StripePaymentReportDTOMeta: StripePaymentReportDTOMetaI =
  {} as StripePaymentReportDTOMetaI;
StripePaymentReportDTOMeta = typeMeta("StripePaymentReportDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
  childReports: propertyMeta("childReports", true, false, false, ReportDTOMeta),
  meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
  typeCounts: propertyMeta(
    "typeCounts",
    true,
    false,
    false,
    ReportTypeCountDTOMeta,
  ),
  transactionType: propertyMeta(
    "transactionType",
    false,
    false,
    false,
    StripeTransactionTypeMeta,
  ),
  stripePaymentIntent: propertyMeta(
    "stripePaymentIntent",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  stripePaymentSecret: propertyMeta(
    "stripePaymentSecret",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  transactionAmountCents: propertyMeta(
    "transactionAmountCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  offSession: propertyMeta(
    "offSession",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  amountReceived: propertyMeta(
    "amountReceived",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountCapturable: propertyMeta(
    "amountCapturable",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountBase: propertyMeta(
    "amountBase",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  capturableDate: propertyMeta(
    "capturableDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paidDate: propertyMeta("paidDate", false, false, false, MetaTypesBase.Date),
  paymentStatus: propertyMeta(
    "paymentStatus",
    false,
    false,
    false,
    PaymentStatusMeta,
  ),
  orderId: propertyMeta("orderId", false, false, false, MetaTypesBase.number),
  paymentDescription: propertyMeta(
    "paymentDescription",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = StripePaymentReportDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ReportDTOMeta]);
  metaI.isDeleted.inheritedFrom = ReportDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = ReportDTOMeta.isNew;
  metaI.reportId.inheritedFrom = ReportDTOMeta.reportId;
  metaI.reportKey.inheritedFrom = ReportDTOMeta.reportKey;
  metaI.reportTitle.inheritedFrom = ReportDTOMeta.reportTitle;
  metaI.reportType.inheritedFrom = ReportDTOMeta.reportType;
  metaI.reportStatus.inheritedFrom = ReportDTOMeta.reportStatus;
  metaI.childReports.inheritedFrom = ReportDTOMeta.childReports;
  metaI.meta.inheritedFrom = ReportDTOMeta.meta;
  metaI.typeCounts.inheritedFrom = ReportDTOMeta.typeCounts;
  metaI.interfaces = metaI.interfaces.concat([StripeTransactionBaseMeta]);
  metaI.transactionType.inheritedFrom =
    StripeTransactionBaseMeta.transactionType;
  metaI.stripePaymentIntent.inheritedFrom =
    StripeTransactionBaseMeta.stripePaymentIntent;
  metaI.stripePaymentSecret.inheritedFrom =
    StripeTransactionBaseMeta.stripePaymentSecret;
  metaI.transactionAmountCents.inheritedFrom =
    StripeTransactionBaseMeta.transactionAmountCents;
  metaI.offSession.inheritedFrom = StripeTransactionBaseMeta.offSession;
});

export class StripePaymentReportDTOTracked
  extends ReportDTOTracked
  implements StripePaymentReportDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  transactionType__I?: StripeTransactionType = undefined;
  transactionTypeIsSet: boolean = false;
  set transactionType(v: undefined | StripeTransactionType) {
    if (v !== undefined) {
      this.transactionType__I = v;
      this.transactionTypeIsSet = true;
    } else {
      this.transactionType__I = v || undefined;
      this.transactionTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionType() {
    return this.transactionType__I;
  }
  stripePaymentIntent__I?: string = undefined;
  stripePaymentIntentIsSet: boolean = false;
  set stripePaymentIntent(v: undefined | string) {
    if (v !== undefined) {
      this.stripePaymentIntent__I = v;
      this.stripePaymentIntentIsSet = true;
    } else {
      this.stripePaymentIntent__I = v || undefined;
      this.stripePaymentIntentIsSet = true;
    }
    this.changeTracker = true;
  }
  get stripePaymentIntent() {
    return this.stripePaymentIntent__I;
  }
  stripePaymentSecret__I?: string = undefined;
  stripePaymentSecretIsSet: boolean = false;
  set stripePaymentSecret(v: undefined | string) {
    if (v !== undefined) {
      this.stripePaymentSecret__I = v;
      this.stripePaymentSecretIsSet = true;
    } else {
      this.stripePaymentSecret__I = v || undefined;
      this.stripePaymentSecretIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripePaymentSecret() {
    return this.stripePaymentSecret__I;
  }
  transactionAmountCents__I?: number = undefined;
  transactionAmountCentsIsSet: boolean = false;
  set transactionAmountCents(v: undefined | number) {
    if (v !== undefined) {
      this.transactionAmountCents__I = v;
      this.transactionAmountCentsIsSet = true;
    } else {
      this.transactionAmountCents__I = v || undefined;
      this.transactionAmountCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get transactionAmountCents() {
    return this.transactionAmountCents__I;
  }
  offSession__I?: boolean = undefined;
  offSessionIsSet: boolean = false;
  set offSession(v: undefined | boolean) {
    if (v !== undefined) {
      this.offSession__I = v;
      this.offSessionIsSet = true;
    } else {
      this.offSession__I = v || undefined;
      this.offSessionIsSet = false;
    }
    this.changeTracker = true;
  }
  get offSession() {
    return this.offSession__I;
  }
  amountReceived__I?: number = undefined;
  amountReceivedIsSet: boolean = false;
  set amountReceived(v: undefined | number) {
    if (v !== undefined) {
      this.amountReceived__I = v;
      this.amountReceivedIsSet = true;
    } else {
      this.amountReceived__I = v || undefined;
      this.amountReceivedIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountReceived() {
    return this.amountReceived__I;
  }
  amountCapturable__I?: number = undefined;
  amountCapturableIsSet: boolean = false;
  set amountCapturable(v: undefined | number) {
    if (v !== undefined) {
      this.amountCapturable__I = v;
      this.amountCapturableIsSet = true;
    } else {
      this.amountCapturable__I = v || undefined;
      this.amountCapturableIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountCapturable() {
    return this.amountCapturable__I;
  }
  amountBase__I?: number = undefined;
  amountBaseIsSet: boolean = false;
  set amountBase(v: undefined | number) {
    if (v !== undefined) {
      this.amountBase__I = v;
      this.amountBaseIsSet = true;
    } else {
      this.amountBase__I = v || undefined;
      this.amountBaseIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountBase() {
    return this.amountBase__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  capturableDate__I?: Date = undefined;
  capturableDateIsSet: boolean = false;
  set capturableDate(v: undefined | Date) {
    if (v !== undefined) {
      this.capturableDate__I = v;
      this.capturableDateIsSet = true;
    } else {
      this.capturableDate__I = v || undefined;
      this.capturableDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get capturableDate() {
    return this.capturableDate__I;
  }
  paidDate__I?: Date = undefined;
  paidDateIsSet: boolean = false;
  set paidDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paidDate__I = v;
      this.paidDateIsSet = true;
    } else {
      this.paidDate__I = v || undefined;
      this.paidDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paidDate() {
    return this.paidDate__I;
  }
  paymentStatus__I?: PaymentStatus = undefined;
  paymentStatusIsSet: boolean = false;
  set paymentStatus(v: undefined | PaymentStatus) {
    if (v !== undefined) {
      this.paymentStatus__I = v;
      this.paymentStatusIsSet = true;
    } else {
      this.paymentStatus__I = v || undefined;
      this.paymentStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentStatus() {
    return this.paymentStatus__I;
  }
  orderId__I?: number = undefined;
  orderIdIsSet: boolean = false;
  set orderId(v: undefined | number) {
    if (v !== undefined) {
      this.orderId__I = v;
      this.orderIdIsSet = true;
    } else {
      this.orderId__I = v || undefined;
      this.orderIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderId() {
    return this.orderId__I;
  }
  paymentDescription__I?: string = undefined;
  paymentDescriptionIsSet: boolean = false;
  set paymentDescription(v: undefined | string) {
    if (v !== undefined) {
      this.paymentDescription__I = v;
      this.paymentDescriptionIsSet = true;
    } else {
      this.paymentDescription__I = v || undefined;
      this.paymentDescriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentDescription() {
    return this.paymentDescription__I;
  }
  constructor(
    config?: StripePaymentReportDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: StripePaymentReportDTOOptional,
    options?: AssignOptions,
  ): StripePaymentReportDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (
      config.transactionType &&
      this.transactionTypeApplyFilter(optionsRequired.filter)
    ) {
      this.transactionType = config.transactionType;
      if (optionsRequired.unassign) this.transactionTypeIsSet = false;
      else this.transactionTypeIsSet = true;
    }
    if (
      config.stripePaymentIntent &&
      this.stripePaymentIntentApplyFilter(optionsRequired.filter)
    ) {
      this.stripePaymentIntent = config.stripePaymentIntent;
      if (optionsRequired.unassign) this.stripePaymentIntentIsSet = false;
      else this.stripePaymentIntentIsSet = true;
    }
    if (
      config.stripePaymentSecret &&
      this.stripePaymentSecretApplyFilter(optionsRequired.filter)
    ) {
      this.stripePaymentSecret = config.stripePaymentSecret;
      if (optionsRequired.unassign) this.stripePaymentSecretIsSet = false;
      else this.stripePaymentSecretIsSet = true;
    }
    if (
      config.transactionAmountCents &&
      this.transactionAmountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.transactionAmountCents = config.transactionAmountCents;
      if (optionsRequired.unassign) this.transactionAmountCentsIsSet = false;
      else this.transactionAmountCentsIsSet = true;
    }
    if (
      config.offSession &&
      this.offSessionApplyFilter(optionsRequired.filter)
    ) {
      this.offSession = config.offSession;
      if (optionsRequired.unassign) this.offSessionIsSet = false;
      else this.offSessionIsSet = true;
    }
    if (
      config.amountReceived &&
      this.amountReceivedApplyFilter(optionsRequired.filter)
    ) {
      this.amountReceived = config.amountReceived;
      if (optionsRequired.unassign) this.amountReceivedIsSet = false;
      else this.amountReceivedIsSet = true;
    }
    if (
      config.amountCapturable &&
      this.amountCapturableApplyFilter(optionsRequired.filter)
    ) {
      this.amountCapturable = config.amountCapturable;
      if (optionsRequired.unassign) this.amountCapturableIsSet = false;
      else this.amountCapturableIsSet = true;
    }
    if (
      config.amountBase &&
      this.amountBaseApplyFilter(optionsRequired.filter)
    ) {
      this.amountBase = config.amountBase;
      if (optionsRequired.unassign) this.amountBaseIsSet = false;
      else this.amountBaseIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (
      config.capturableDate &&
      this.capturableDateApplyFilter(optionsRequired.filter)
    ) {
      this.capturableDate = config.capturableDate;
      if (optionsRequired.unassign) this.capturableDateIsSet = false;
      else this.capturableDateIsSet = true;
    }
    if (config.paidDate && this.paidDateApplyFilter(optionsRequired.filter)) {
      this.paidDate = config.paidDate;
      if (optionsRequired.unassign) this.paidDateIsSet = false;
      else this.paidDateIsSet = true;
    }
    if (
      config.paymentStatus &&
      this.paymentStatusApplyFilter(optionsRequired.filter)
    ) {
      this.paymentStatus = config.paymentStatus;
      if (optionsRequired.unassign) this.paymentStatusIsSet = false;
      else this.paymentStatusIsSet = true;
    }
    if (config.orderId && this.orderIdApplyFilter(optionsRequired.filter)) {
      this.orderId = config.orderId;
      if (optionsRequired.unassign) this.orderIdIsSet = false;
      else this.orderIdIsSet = true;
    }
    if (
      config.paymentDescription &&
      this.paymentDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.paymentDescription = config.paymentDescription;
      if (optionsRequired.unassign) this.paymentDescriptionIsSet = false;
      else this.paymentDescriptionIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): StripePaymentReportDTOTrackedI {
    const cloned = {} as StripePaymentReportDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (
      this.transactionTypeIsSetDeep() &&
      this.transactionTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionTypeIsSet = true;
      cloned.transactionType = this.transactionType;
    } else {
      //cloned.transactionTypeIsSet = false
    }
    if (
      this.stripePaymentIntentIsSetDeep() &&
      this.stripePaymentIntentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripePaymentIntentIsSet = true;
      cloned.stripePaymentIntent = this.stripePaymentIntent;
    } else {
      //cloned.stripePaymentIntentIsSet = false
    }
    if (
      this.stripePaymentSecretIsSetDeep() &&
      this.stripePaymentSecretApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripePaymentSecretIsSet = true;
      cloned.stripePaymentSecret = this.stripePaymentSecret;
    } else {
      //cloned.stripePaymentSecretIsSet = false
    }
    if (
      this.transactionAmountCentsIsSetDeep() &&
      this.transactionAmountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionAmountCentsIsSet = true;
      cloned.transactionAmountCents = this.transactionAmountCents;
    } else {
      //cloned.transactionAmountCentsIsSet = false
    }
    if (
      this.offSessionIsSetDeep() &&
      this.offSessionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.offSessionIsSet = true;
      cloned.offSession = this.offSession;
    } else {
      //cloned.offSessionIsSet = false
    }
    if (
      this.amountReceivedIsSetDeep() &&
      this.amountReceivedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountReceivedIsSet = true;
      cloned.amountReceived = this.amountReceived;
    } else {
      //cloned.amountReceivedIsSet = false
    }
    if (
      this.amountCapturableIsSetDeep() &&
      this.amountCapturableApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCapturableIsSet = true;
      cloned.amountCapturable = this.amountCapturable;
    } else {
      //cloned.amountCapturableIsSet = false
    }
    if (
      this.amountBaseIsSetDeep() &&
      this.amountBaseApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountBaseIsSet = true;
      cloned.amountBase = this.amountBase;
    } else {
      //cloned.amountBaseIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.capturableDateIsSetDeep() &&
      this.capturableDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.capturableDateIsSet = true;
      cloned.capturableDate = this.capturableDate;
    } else {
      //cloned.capturableDateIsSet = false
    }
    if (
      this.paidDateIsSetDeep() &&
      this.paidDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paidDateIsSet = true;
      cloned.paidDate = this.paidDate;
    } else {
      //cloned.paidDateIsSet = false
    }
    if (
      this.paymentStatusIsSetDeep() &&
      this.paymentStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentStatusIsSet = true;
      cloned.paymentStatus = this.paymentStatus;
    } else {
      //cloned.paymentStatusIsSet = false
    }
    if (
      this.orderIdIsSetDeep() &&
      this.orderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderIdIsSet = true;
      cloned.orderId = this.orderId;
    } else {
      //cloned.orderIdIsSet = false
    }
    if (
      this.paymentDescriptionIsSetDeep() &&
      this.paymentDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentDescriptionIsSet = true;
      cloned.paymentDescription = this.paymentDescription;
    } else {
      //cloned.paymentDescriptionIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): StripePaymentReportDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    if (!this.transactionTypeApplyFilter(filter))
      this.transactionTypeIsSet = false;

    if (!this.stripePaymentIntentApplyFilter(filter))
      this.stripePaymentIntentIsSet = false;

    if (!this.stripePaymentSecretApplyFilter(filter))
      this.stripePaymentSecretIsSet = false;

    if (!this.transactionAmountCentsApplyFilter(filter))
      this.transactionAmountCentsIsSet = false;

    if (!this.offSessionApplyFilter(filter)) this.offSessionIsSet = false;

    if (!this.amountReceivedApplyFilter(filter))
      this.amountReceivedIsSet = false;

    if (!this.amountCapturableApplyFilter(filter))
      this.amountCapturableIsSet = false;

    if (!this.amountBaseApplyFilter(filter)) this.amountBaseIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.capturableDateApplyFilter(filter))
      this.capturableDateIsSet = false;

    if (!this.paidDateApplyFilter(filter)) this.paidDateIsSet = false;

    if (!this.paymentStatusApplyFilter(filter)) this.paymentStatusIsSet = false;

    if (!this.orderIdApplyFilter(filter)) this.orderIdIsSet = false;

    if (!this.paymentDescriptionApplyFilter(filter))
      this.paymentDescriptionIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.isDeleted,
      StripePaymentReportDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.isNew,
      StripePaymentReportDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.reportId,
      StripePaymentReportDTOMeta,
      this.reportId,
      this,
    );
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.reportKey,
      StripePaymentReportDTOMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.reportTitle,
      StripePaymentReportDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.reportType,
      StripePaymentReportDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.reportStatus,
      StripePaymentReportDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.childReports,
      StripePaymentReportDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.meta,
      StripePaymentReportDTOMeta,
      this.meta,
      this,
    );
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.typeCounts,
      StripePaymentReportDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  transactionTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.transactionType,
      StripePaymentReportDTOMeta,
      this.transactionType,
      this,
    );
  }
  transactionTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.transactionTypeIsSet && this.transactionTypeApplyFilter(filter))
      return true;

    return false;
  }
  stripePaymentIntentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.stripePaymentIntent,
      StripePaymentReportDTOMeta,
      this.stripePaymentIntent,
      this,
    );
  }
  stripePaymentIntentIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripePaymentIntentIsSet &&
      this.stripePaymentIntentApplyFilter(filter)
    )
      return true;

    return false;
  }
  stripePaymentSecretApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.stripePaymentSecret,
      StripePaymentReportDTOMeta,
      this.stripePaymentSecret,
      this,
    );
  }
  stripePaymentSecretIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripePaymentSecretIsSet &&
      this.stripePaymentSecretApplyFilter(filter)
    )
      return true;

    return false;
  }
  transactionAmountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.transactionAmountCents,
      StripePaymentReportDTOMeta,
      this.transactionAmountCents,
      this,
    );
  }
  transactionAmountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.transactionAmountCentsIsSet &&
      this.transactionAmountCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  offSessionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.offSession,
      StripePaymentReportDTOMeta,
      this.offSession,
      this,
    );
  }
  offSessionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.offSessionIsSet && this.offSessionApplyFilter(filter)) return true;

    return false;
  }
  amountReceivedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.amountReceived,
      StripePaymentReportDTOMeta,
      this.amountReceived,
      this,
    );
  }
  amountReceivedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountReceivedIsSet && this.amountReceivedApplyFilter(filter))
      return true;

    return false;
  }
  amountCapturableApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.amountCapturable,
      StripePaymentReportDTOMeta,
      this.amountCapturable,
      this,
    );
  }
  amountCapturableIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountCapturableIsSet && this.amountCapturableApplyFilter(filter))
      return true;

    return false;
  }
  amountBaseApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.amountBase,
      StripePaymentReportDTOMeta,
      this.amountBase,
      this,
    );
  }
  amountBaseIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountBaseIsSet && this.amountBaseApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.createdOn,
      StripePaymentReportDTOMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  capturableDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.capturableDate,
      StripePaymentReportDTOMeta,
      this.capturableDate,
      this,
    );
  }
  capturableDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.capturableDateIsSet && this.capturableDateApplyFilter(filter))
      return true;

    return false;
  }
  paidDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.paidDate,
      StripePaymentReportDTOMeta,
      this.paidDate,
      this,
    );
  }
  paidDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paidDateIsSet && this.paidDateApplyFilter(filter)) return true;

    return false;
  }
  paymentStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.paymentStatus,
      StripePaymentReportDTOMeta,
      this.paymentStatus,
      this,
    );
  }
  paymentStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentStatusIsSet && this.paymentStatusApplyFilter(filter))
      return true;

    return false;
  }
  orderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.orderId,
      StripePaymentReportDTOMeta,
      this.orderId,
      this,
    );
  }
  orderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderIdIsSet && this.orderIdApplyFilter(filter)) return true;

    return false;
  }
  paymentDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportDTOMeta.paymentDescription,
      StripePaymentReportDTOMeta,
      this.paymentDescription,
      this,
    );
  }
  paymentDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentDescriptionIsSet &&
      this.paymentDescriptionApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    if (this.transactionTypeIsSetDeep(filter)) return true;
    if (this.stripePaymentIntentIsSetDeep(filter)) return true;
    if (this.stripePaymentSecretIsSetDeep(filter)) return true;
    if (this.transactionAmountCentsIsSetDeep(filter)) return true;
    if (this.offSessionIsSetDeep(filter)) return true;
    if (this.amountReceivedIsSetDeep(filter)) return true;
    if (this.amountCapturableIsSetDeep(filter)) return true;
    if (this.amountBaseIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.capturableDateIsSetDeep(filter)) return true;
    if (this.paidDateIsSetDeep(filter)) return true;
    if (this.paymentStatusIsSetDeep(filter)) return true;
    if (this.orderIdIsSetDeep(filter)) return true;
    if (this.paymentDescriptionIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
